import React from 'react';
import ReactTooltip from 'react-tooltip';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ReceivingExpandListTemplate = ({ viewStore, viewStore: { tableData, noDataItem, data, change, loading } }) => {
	if (loading) return null;
	return (
		<React.Fragment>
			<BaasicTable
				{...{
					data,
					tableData,
					viewStore,
					noDataItem,
					showImage: false,
					change,
				}}
				actions={viewStore}
			/>
			<ReactTooltip />
		</React.Fragment>
	);
};

export default defaultTemplate(ReceivingExpandListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/ReceivingExpandListTemplate.jsx